export default {"src":"/_next/static/media/caret.13506650.svg","height":10,"width":11,"blurWidth":0,"blurHeight":0};